import { Subject } from 'rxjs';

export const BusService = {
  snackbarSubject:                    new Subject(),
  userSubtitlesListSubject:           new Subject(),
  userSubtitleSubject:                new Subject(),
  cancelAddingSubtitlesSubject:       new Subject(),
  cancelCancelingSubtitlesSubject:    new Subject(),
  subtitlesLoadedSuccessfullySubject: new Subject(),
  addSubtitlesSubject:                new Subject(),
  switchOverlaySubject:               new Subject(),
  videoLoaded:                        new Subject(),
  unloadVideo:                        new Subject(),
};
